module.exports = __webpack_public_path__ + "img/linkedin.b1b9b579.svg";